import { Component, OnInit, ElementRef, Pipe, PipeTransform, Injectable, Input } from '@angular/core';
import { DataService } from '../data.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-root',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.css']
})
         

export class RootComponent implements OnInit {
    public jsondata = new Array<any>();
    public arrTable = new Array<any>();
    public arrTable1 = new Array<any>();
    public arrTableDistinct = new Array<any>();
    mainwebpageid: number;
    webpagedefinitiontypeid: number;
    cachestring = '';
    questionaryid = 0;
    questionaryanswerhashcode = '';
    pagenumber = 0;

    @Input() webpageid: number;
    @Input() mainpagewebpageid: number;
   

    constructor(public dataservice: DataService, private _elementRef: ElementRef, private httpClient: HttpClient) {
        this.mainwebpageid = this._elementRef.nativeElement.getAttribute("mainwebpageid");
        this.cachestring = this._elementRef.nativeElement.getAttribute("cachestring");
        this.questionaryid = this._elementRef.nativeElement.getAttribute("questionaryid");
        this.questionaryanswerhashcode = this._elementRef.nativeElement.getAttribute("questionaryanswerhashcode");
        this.pagenumber = this._elementRef.nativeElement.getAttribute("pagenumber");
        if (!this.questionaryid) this.questionaryid = 0;
    }

    ngOnInit() {

        if (this.cachestring != null) {
            //remove old keys if cache refresh
            if (!localStorage.getItem("cachestring") || localStorage.getItem("cachestring") != this.cachestring) {
                localStorage.clear();
                localStorage.setItem("cachestring", this.cachestring);
            }
        }

        if (this.webpageid > 0)
            this.mainwebpageid = this.webpageid;

        //get grid
        if (this.questionaryid == 0)
            this.dataservice.getWebPageGrid(this.mainwebpageid, (returndata: any) => { this.loadGrid(returndata) });
    }


    //load grid
    public loadGrid(data: any) {
        this.jsondata = data;
        for (let entry of data.Table) {
            const index = this.arrTableDistinct.findIndex((e) => e.responsiverow === entry.responsiverow);
            if (index === -1) {
                this.arrTableDistinct.push(entry);
            }
        }

        this.arrTable = data.Table;
        this.arrTable1 = data.Table1;

        this.webpagedefinitiontypeid = data.Table[0].webpagedefinitiontypeid;
    }

    //check if container page width
    isRowContainerPageWidth(responsiverow) {
        return this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.iscontainerpagewidth == 1)).length;
    }

    //get table by row
    getTable(responsiverow, col) {
        return this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col === col));
    }

    //get table1 by row
    getTable1(responsiverow) {
        return this.arrTable1.filter((item) => (item.responsiverow === responsiverow));
    }

    returnvalue: string = "";
    public getElementMainClasses(responsiverow, col) {
        this.returnvalue = "";

        //large
        var large = this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col));
        for (let table of large.sort((a, b) => b.lgwidthincolumns - a.lgwidthincolumns).entries()) {
            if (table[0] == 0 && table[1].lgwidthincolumns > 0)
                this.returnvalue += " col-lg-" + table[1].lgwidthincolumns + " ";
        }

        //medium
        for (let table of this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col)).sort((a, b) => b.mdwidthincolumns - a.mdwidthincolumns).entries()) {
            if (table[0] == 0) {
                if (table[1].mdwidthincolumns > 0)
                    this.returnvalue += " col-md-" + table[1].mdwidthincolumns + " ";
                else 
                    this.returnvalue += " col-md-12 ";
            }
        }

        //small
        for (let table of this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col)).sort((a, b) => b.smwidthincolumns - a.smwidthincolumns).entries()) {
            if (table[0] == 0) {
                if (table[1].smwidthincolumns > 0)
                    this.returnvalue += " col-sm-" + table[1].smwidthincolumns + " ";
                else
                    this.returnvalue += " col-sm-12 ";
            }
        }

        //xsmall
        for (let table of this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col)).sort((a, b) => b.xswidthincolumns - a.xswidthincolumns).entries()) {
            if (table[0] == 0) {
                if (table[1].xswidthincolumns > 0)
                    this.returnvalue += " col-xs-" + table[1].xswidthincolumns + " ";
                else
                    this.returnvalue += " col-xs-12 ";
            }
        }

        //push / pull
        if (this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col)).length == 1) {
            for (let table of this.arrTable.filter((item) => (item.responsiverow === responsiverow && item.col == col)).entries()) {
                if (table[0] == 0) {
                    this.returnvalue += " columhholder_" + table[1].webpagedefinitionitemid + " ";

                    if (table[1].pushmd > 0) this.returnvalue += " col-md-push-" + table[1].pushmd + " ";
                    if (table[1].pushmd < 0) this.returnvalue += " col-md-pull-" + (table[1].pushmd * -1) + " ";

                    if (table[1].pushsm > 0) this.returnvalue += " col-sm-push-" + table[1].pushsm + " ";
                    if (table[1].pushsm < 0) this.returnvalue += " col-sm-pull-" + (table[1].pushsm * -1) + " ";

                    if (table[1].pushxs > 0) this.returnvalue += " col-xs-push-" + table[1].pushxs + " ";
                    if (table[1].pushxs < 0) this.returnvalue += " col-xs-pull-" + (table[1].pushxs * -1) + " ";

                 

                }
            }
        }
        return this.returnvalue;
    }

    public parseToInt(value) {
        return (isNaN(parseInt(value)) ? '0' : String(parseInt(value)));
    }
}

